// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__18XNp","inner":"Footer_inner__mmiKD","nextIcon":"Footer_nextIcon__31YWs","innerLeft":"Footer_innerLeft__1FxhZ"};